export default "__VITE_ASSET__BCvs_tTG__"